import { ODataOptions } from 'src/util/ODataBuilder';
import BaseApi from './BaseApi';
import CountyModel from 'src/models/County';

export interface ICounty {
    getCountiesForState(stateId: number, options: ODataOptions, jwt: string): Promise<object>;
    getCountiesForProject(clientNumber: number, projectNumber: number, options: ODataOptions, jwt: string): Promise<object>;
    getCountiesForTownship(clientNumber: number, projectNumber: number, townshipNumber: number, options: ODataOptions, jwt: string): Promise<object>;
    getCountiesForSection(clientNumber: number, projectNumber: number, sectionNumber: number, options: ODataOptions, jwt: string): Promise<object>;
    getCountiesForEasternMap(clientNumber: number, projectNumber: number, mapNumber: number, options: ODataOptions, jwt: string): Promise<object>;
    getCountiesForTract(
        clientNumber: number,
        projectNumber: number,
        townshipNumber: number,
        sectionNumber: number,
        tractNumber: number,
        options: ODataOptions,
        jwt: string
    ): Promise<object>;
    createCounty(clientNumber: number, projectNumber: number, county: CountyModel, jwt: string): Promise<object>;
}

export default class County extends BaseApi implements ICounty {
    constructor(baseUrl: string) {
        super(baseUrl);
    }
    getCountiesForState = (stateId: number, options: ODataOptions, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/states/${stateId}/counties/${options.toString()}`, jwt);
    };
    getCountiesForProject = (clientNumber: number, projectNumber: number, options: ODataOptions, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/counties/${options.toString()}`, jwt);
    };
    getCountiesForTownship = (clientNumber: number, projectNumber: number, townshipNumber: number, options: ODataOptions, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships/${townshipNumber}/counties/${options.toString()}`,
            jwt
        );
    };
    getCountiesForSection = (clientNumber: number, projectNumber: number, sectionNumber: number, options: ODataOptions, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/sections/${sectionNumber}/counties/${options.toString()}`,
            jwt
        );
    };
    getCountiesForEasternMap = (clientNumber: number, projectNumber: number, mapNumber: number, options: ODataOptions, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/maps/${mapNumber}/counties/${options.toString()}`,
            jwt
        );
    };
    getCountiesForTract = (
        clientNumber: number,
        projectNumber: number,
        townshipNumber: number,
        sectionNumber: number,
        tractNumber: number,
        options: ODataOptions,
        jwt: string
    ) => {
        // tslint:disable-next-line:max-line-length
        return this.getRequest(
            `${
                this.baseUrl
            }v1.0/clients/${clientNumber}/projects/${projectNumber}/townships/${townshipNumber}/sections/${sectionNumber}/tracts/${tractNumber}/counties/${options.toString()}`,
            jwt
        );
    };
    createCounty = (clientNumber: number, projectNumber: number, county: CountyModel, jwt: string) => {
        const c = { county };
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/counties`, c, jwt);
    };
}



// WEBPACK FOOTER //
// ./src/api/County.ts